module.exports = __webpack_public_path__ + "img/checked-icon.467f4b0a.png";